export default {
    currentPassword: '現在のパスワード',
    password: '新しいパスワード',
    rePassword: '確認用パスワード'
};
